function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon / Storm / outage-FAQs");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Icon-/-Storm-/-outage-FAQs",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(4.000000, 7.000000)",
  stroke: "#00148C"
}, /*#__PURE__*/React.createElement("g", {
  id: "wall-socket-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.8666469,24.5535005 C26.9392552,23.1505706 25.2845868,22.2998305 23.5,22.4791667 C20.9710643,22.2250296 18.7030269,24.0394595 18.3958333,26.5625 L18.3958333,26.5625 L18.3958333,32.6875 L22.755789,32.6875",
  id: "Path",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  x1: 14.3125,
  y1: 8.1875,
  x2: 14.3125,
  y2: 18.3958333,
  id: "Path",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  x1: 32.6875,
  y1: 8.1875,
  x2: 32.6875,
  y2: 18.3958333,
  id: "Path",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.9553601,17.6954959 C46.6801042,7.79088022 44.0520737,0.0208333333 40.8541667,0.0208333333 L6.14583333,0.0208333333 C2.76279167,0.0208333333 0.0208333333,8.70608333 0.0208333333,19.4166667 C0.0208333333,30.12725 2.76279167,38.8125 6.14583333,38.8125 C13.314767,38.8125 18.6914673,38.8125 22.2759341,38.8125",
  id: "Shape"
})), /*#__PURE__*/React.createElement("g", {
  id: "calendar-question",
  transform: "translate(26.000000, 21.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  strokeLinecap: "round",
  cx: 15.2916667,
  cy: 15.2940833,
  r: 14.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.7604167,11.7681667 C10.7604167,9.26562639 12.7891264,7.23691667 15.2916667,7.23691667 C17.7942069,7.23691667 19.8229167,9.26562639 19.8229167,11.7681667 C19.8229167,14.2707069 17.7942069,16.2994167 15.2916667,16.2994167 L15.2916667,18.7160833",
  id: "Path",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.2916667,23.5494167 C15.6253387,23.5494167 15.8958333,23.8199113 15.8958333,24.1535833 C15.8958333,24.4872554 15.6253387,24.75775 15.2916667,24.75775 C14.9579946,24.75775 14.6875,24.4872554 14.6875,24.1535833 C14.6875,23.8199113 14.9579946,23.5494167 15.2916667,23.5494167",
  id: "Path",
  strokeWidth: 2,
  strokeLinecap: "round"
}))));

var SvgOutageFaQs = function SvgOutageFaQs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOutageFaQs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/outage-FAQs.328b9209.svg";
export { ForwardRef as ReactComponent };